/** 모바일 — 회원권 잔여횟수 조회 (이용중 회원권, 잔여 적은 순) */
import React, { useMemo, useState } from 'react';
import { loadTable, passRemain, num, fmt } from 'shop/shopStore';
import { Page, H, CardBox, Field, Chip } from './mobileUi';

const MobilePass = ({ tc }) => {
  const [kw, setKw] = useState('');
  const rows = useMemo(() => {
    const cs = new Map(loadTable(tc, 'customer').map((c) => [c.customerUid, c]));
    const ss = new Map(loadTable(tc, 'service').map((s) => [s.serviceUid, s]));
    const q = kw.trim().toLowerCase();
    return loadTable(tc, 'pass')
      .filter((p) => p.status === 'ACTIVE')
      .map((p) => ({ ...p, cn: cs.get(p.customerUid)?.customerNm || '-', sn: ss.get(p.serviceUid)?.serviceNm || '-', remain: passRemain(p) }))
      .filter((p) => !q || `${p.cn} ${p.sn}`.toLowerCase().includes(q))
      .sort((a, b) => a.remain - b.remain);
  }, [tc, kw]);

  return (
    <Page>
      <H>회원권 잔여</H>
      <Field>검색
        <input value={kw} onChange={(e) => setKw(e.target.value)} placeholder="고객·서비스" />
      </Field>
      {rows.length === 0 && <span className="s">이용중인 회원권이 없습니다.</span>}
      {rows.map((p) => (
        <CardBox key={p.passUid} $warn={p.remain <= 2}>
          <span className="t">{p.cn} · {p.sn}</span>
          <span className="n">{p.remain} / {num(p.totalCnt)}회</span>
          <span className="s">
            결제 ₩{fmt(p.price)}{p.expiryDate ? ` · 만료 ${p.expiryDate}` : ''}
          </span>
          <span>{p.recurringYn === 'Y' && <Chip>정기결제</Chip>} {p.remain <= 2 && <Chip $warn>잔여 임박</Chip>}</span>
        </CardBox>
      ))}
    </Page>
  );
};

export default MobilePass;
